<template>
  <v-container v-if="!loading" fill-height class="login-bg bg-black">
    <v-layout align-center justify-center wrap fill-height>
      <v-flex xs12 sm8 md4 class="text-md-center">
        <div class="layout column align-center mb-4">
          <v-img :src="logo" contain class="login-logo"/>
        </div>
        <div class="login-header m-t-25 white--text text-center">
          <h1 class="m-b-10">Welcome Affiliate!</h1>
          <p>Log in your account.</p>
        </div>
        <div class="login-tab-wrapper">
          <login-form username-label="Email" v-model="loginEmail" @logined="redirectToDashboard" @failed="loginFailed"></login-form>
          <div class="m-t-10 text-center">
            <router-link to="forgot-password" class="no-line font-sm">Forgot Password</router-link>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <error-dialog ref="childError" title="Error" :message="errorMsg" :open="errorDialog" toPage=""></error-dialog>
  </v-container>
</template>

<script>
import LoginForm from '@/components/forms/LoginForm'
import ErrorDialog from '@/components/elements/dialog/ErrorDialog'
import { mapActions, mapGetters } from 'vuex'
import storage from '../utility/storage'

export default {
  components: { LoginForm, ErrorDialog },
  data () {
    return {
      loginPhone: {
        username: '',
        password: '',
        countryPhone: '+63'
      },
      loginEmail: {
        username: '',
        password: ''
      },
      activeTab: null,
      logo: require('@/assets/piwi-logo.svg'),
      errorDialog: false,
      loading: true,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['status']),
  },
  methods: {
    ...mapActions('member', {'loadMember': 'getMember'}),
    redirectToDashboard () {
      this.loadMember().then(res => {
        if (res.status === 200 && res.data.user) {
          this.$router.push({ name: 'dashboard' })
        }
      }).catch(() => {
        // Inactive/deactivated account
        this.openErrDialog('Account cannot be logged in. Please contact support.')
      });
    },
    loginFailed(err) {
      // Invalid credentials
      if (err.status === 422) {
        this.openErrDialog('Account does not exist or invalid credentials.')
      }
    },
    openErrDialog(msg) {
      this.$refs.childError.setOpen(true)
      this.errorMsg = msg;
    }
  },
  mounted() {
    if (storage.getString('is_undermaintenance') == 'true') {
      this.$router.push({name: 'maintenance'})
    } else {
      this.loading = false
    }
  }
}
</script>

<style scoped>
  
</style>
